import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useAuth } from '../AuthContext';
import { getDeliveries } from '../api';
import { Header, Loader, StatusBadge, Modal } from '../components';
import { IconHome, IconPhone, IconPerson, IconClock } from '../Icons';

const parseTime = (time) => {
  if (!time) return '';
  const parts = time.split(' ');
  if (parts.length < 2) return time;
  const timeParts = parts[1].split(':');
  return `${parts[0]} | ${timeParts[0]}:${timeParts[1]}`;
};

const requestNotificationPermission = async () => {
  if (!('Notification' in window)) return false;
  if (Notification.permission === 'granted') return true;
  if (Notification.permission === 'denied') return false;
  const permission = await Notification.requestPermission();
  return permission === 'granted';
};

const sendNotification = (order) => {
  if (!('Notification' in window) || Notification.permission !== 'granted') return;
  const addr = order.deliveryPoint?.address;
  const addrText = addr.line1
  // const addrText = addr
  //   ? `${addr.street?.name}, ${addr.house}`
  //   : '';
  new Notification(`🍕 Новый заказ №${order.number}`, {
    body: addrText || 'Новая доставка',
    icon: '/icons/icon-192.png',
    badge: '/icons/icon-192.png',
    vibrate: [200, 100, 200],
  });
};

const ListDeliveryScreen = ({ navigate }) => {
  const { courierId, organizationId } = useAuth();
  const [data, setData] = useState([]);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const knownIds = useRef(new Set());
  const isFirstLoad = useRef(true);

  const load = useCallback(async (isRefresh = false) => {
    if (!isRefresh) setLoading(true);
    try {
      const result = await getDeliveries();
      if (result.message) {
        setData([]);
        setMessage(result.message);
      } else {
        const orders = Array.isArray(result) ? result : [];
        
        // Проверяем новые заказы (не при первой загрузке)
        if (!isFirstLoad.current) {
          orders.forEach((item) => {
            if (!knownIds.current.has(item.id)) {
              sendNotification(item.order);
            }
          });
        }

        // Обновляем список известных ID
        knownIds.current = new Set(orders.map((o) => o.id));
        isFirstLoad.current = false;

        setData(orders);
        setMessage('');
      }
    } catch {
      setMessage('Ошибка загрузки. Нажмите для обновления.');
    } finally {
      setLoading(false);
    }
  }, []);

  // Запрос разрешения и первая загрузка
  useEffect(() => {
    requestNotificationPermission();
    load();
  }, [load]);

  // Автообновление каждые 30 сек
  useEffect(() => {
    const interval = setInterval(() => load(true), 30000);
    return () => clearInterval(interval);
  }, [load]);

  const goToOrder = (item) => {
    navigate('order', { orderId: item.id, orgId: item.organizationId, number: item.order.number, from: 'list' });
  };

  return (
    <>
      <Header
        title="Список доставок"
        onBack={() => setShowLogoutModal(true)}
        onHistory={() => navigate('history')}
      />
      <div className="screen">
        <div className="screen-content">
          {loading ? (
            <Loader />
          ) : message ? (
            <div className="empty-state">{message}</div>
          ) : data.length === 0 ? (
            <div className="empty-state">Нет активных доставок</div>
          ) : (
            data.map((item) => (
              <div key={item.id} className="order-card" onClick={() => goToOrder(item)}>
                <div className="order-number">Заказ №{item.order.number}</div>
                <div className="order-row">
                  <IconHome />
                  <span>
                    {item.order.deliveryPoint?.address.line1}
                    {/* г.&nbsp;{item.order.deliveryPoint?.address.street.city.name},&nbsp;
                    ул.&nbsp;{item.order.deliveryPoint?.address.street.name}&nbsp;
                    {item.order.deliveryPoint?.address.building},&nbsp;
                    кв.&nbsp;{item.order.deliveryPoint?.address.house} */}
                  </span>
                </div>
                <div className="order-row">
                  <IconPhone />
                  <span>{item.order.phone}</span>
                </div>
                <div className="order-row">
                  <IconPerson />
                  <span>{item.order.customer?.name}</span>
                </div>
                <div className="order-last-row">
                  <div className="order-row" style={{ marginBottom: 0 }}>
                    <IconClock />
                    <span>{parseTime(item.order.cookingStartTime)}</span>
                  </div>
                  <StatusBadge status={item.order.status} />
                </div>
              </div>
            ))
          )}

          {!loading && (
            <div className="pull-hint" onClick={() => load(true)}>
              ↻ Обновить список
            </div>
          )}
        </div>
      </div>

      <Modal isVisible={showLogoutModal} onClose={() => setShowLogoutModal(false)}>
        <div className="modal-title">Хотите вернуться на страницу входа?</div>
        <button className="btn" onClick={() => { setShowLogoutModal(false); navigate('logout'); }}>
          Перейти к выходу
        </button>
      </Modal>
    </>
  );
};

export default ListDeliveryScreen;
